import { validateResponse, checkResponseError } from "../lib/validateResponse";

import {
  ENABLE_FORM,
  DISABLE_FORM,
  CLEAR_FORM,
  SET_FORM_ERROR,
  SET_FORM_ERRORS,
  CLEAR_FORM_ERROR,
  SET_FORM_FIELD,
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR,
  SET_IS_FORM_ERROR_VISIBLE
} from "../lib/formsReducer";
import {
  SET_ENTITY_FIELD,
  SET_SEARCH_FIELD,
  SET_PAGINATION_PAGE
} from "../lib/entitiesReducer";

export const SET_ONLINE = "SET_ONLINE";
export const SET_IS_ONLINE_INTERVAL = "SET_IS_ONLINE_INTERVAL";
export const SET_REFRESH_TOKEN_INTERVAL = "SET_REFRESH_TOKEN_INTERVAL";
export const SET_SIDEBAR = "SET_SIDEBAR";
export const UPDATE_MEDIA_QUERY = "UPDATE_MEDIA_QUERY";
export const SET_PATCH_SUCCESS_FALSE = "SET_PATCH_SUCCESS_FALSE";
export const SET_POST_SUCCESS_FALSE = "SET_POST_SUCCESS_FALSE";
export const SET_SHOULD_MENU_LEFT_RERENDER = "SET_SHOULD_MENU_LEFT_RERENDER";
export const SET_DRAGGING_ITEM_UID = "SET_DRAGGING_ITEM_UID";
export const SET_HOVERING_ITEM_UID = "SET_HOVERING_ITEM_UID";
export const SET_IS_DAY_PICKER_VISIBLE = "SET_IS_DAY_PICKER_VISIBLE";

export function setOnline(online) {
  return {
    type: SET_ONLINE,
    payload: online
  };
}

export function setIsOnlineInterval(interval) {
  return {
    type: SET_IS_ONLINE_INTERVAL,
    payload: interval
  };
}

export function setSidebar(key, value) {
  return {
    type: SET_SIDEBAR,
    payload: {
      key,
      value
    }
  };
}

export function setPatchSuccessFalse() {
  return {
    type: SET_PATCH_SUCCESS_FALSE
  };
}

export function setPostSuccessFalse() {
  return {
    type: SET_POST_SUCCESS_FALSE
  };
}

export function updateMediaQuery() {
  return {
    type: UPDATE_MEDIA_QUERY
  };
}

export function setRefreshTokenInterval(interval) {
  return {
    type: SET_REFRESH_TOKEN_INTERVAL,
    payload: interval
  };
}

// form actions
export function clearForm(feature, form) {
  return {
    type: `${CLEAR_FORM}_${feature.toUpperCase()}`,
    payload: {
      form
    }
  };
}

export function disableForm(feature, form) {
  return {
    type: `${DISABLE_FORM}_${feature.toUpperCase()}`,
    payload: {
      form
    }
  };
}

export function enableForm(feature, form) {
  return {
    type: `${ENABLE_FORM}_${feature.toUpperCase()}`,
    payload: {
      form
    }
  };
}

export function setFormError(feature, form, errors, name) {
  return {
    type: `${SET_FORM_ERROR}_${feature.toUpperCase()}`,
    payload: {
      form,
      errors,
      name
    }
  };
}

export function setFormErrors(feature, form, errors) {
  return {
    type: `${SET_FORM_ERRORS}_${feature.toUpperCase()}`,
    payload: {
      form,
      errors
    }
  };
}

export function clearFormError(feature, form, name) {
  return {
    type: `${CLEAR_FORM_ERROR}_${feature.toUpperCase()}`,
    payload: {
      form,
      name
    }
  };
}

export function setFormField(feature, form, name, value) {
  return {
    type: `${SET_FORM_FIELD}_${feature.toUpperCase()}`,
    payload: {
      form,
      name,
      value
    }
  };
}

export function setIsFormErrorVisible(feature, form, key, value) {
  return {
    type: `${SET_IS_FORM_ERROR_VISIBLE}_${feature.toUpperCase()}`,
    payload: {
      form,
      key,
      value
    }
  };
}

// entities actions
export function setEntityField(feature, uid, name, value, collectionItemUID) {
  return {
    type: `${SET_ENTITY_FIELD}_${feature.toUpperCase()}`,
    payload: {
      uid,
      name,
      value,
      collectionItemUID
    }
  };
}

export function removeHistory() {
  return {
    type: "RESET_HISTORY"
  };
}

export function setSearchField(feature, field, value) {
  return {
    type: `${SET_SEARCH_FIELD}_${feature.toUpperCase()}`,
    payload: {
      field,
      value
    }
  };
}

export function setPaginationPage(feature, value) {
  return {
    type: `${SET_PAGINATION_PAGE}_${feature.toUpperCase()}`,
    payload: {
      value
    }
  };
}

export function setShouldMenuLeftRerender(boolean) {
  return {
    type: SET_SHOULD_MENU_LEFT_RERENDER,
    data: {
      shouldRerender: boolean
    }
  };
}

export function setDraggingItemUID(uid) {
  return {
    type: SET_DRAGGING_ITEM_UID,
    payload: {
      uid
    }
  };
}

export function setHoveringItemUID(uid) {
  return {
    type: SET_HOVERING_ITEM_UID,
    payload: {
      uid
    }
  };
}

export function setIsDayPickerVisible(value) {
  return {
    type: SET_IS_DAY_PICKER_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function cleanSearch() {
  return {
    type: "CLEAN_SEARCH"
  };
}



// WEBPACK FOOTER //
// ./src/common/settings/actions.js